import { reactive } from "vue"
import iStoreUtils from '@/scripts/istore-utils'
import { langControl } from '@/scripts/istore-ui-lang.js'

const notificationService = {
  data: reactive({
    notifications: []
  }),
  addNotification(msgObj) {
    // type: 'info', 'warning', 'alert'
    if (typeof msgObj === 'object') {
      let msgTitle
      if (msgObj.type === 'info') {
        msgTitle = langControl.currentLangKey['titleInfoNotification']
      } else if (msgObj.type === 'warning') {
        msgTitle = langControl.currentLangKey['titleWarningNotification']
      } else if (msgObj.type === 'alert') {
        msgTitle = langControl.currentLangKey['titleAlertNotification']
      } else {
        msgTitle = langControl.currentLangKey['titleOtherNotification']
      }
      this.data.notifications.unshift({
        type: msgObj.type,
        title: msgTitle,
        message: msgObj.message,
        time: iStoreUtils.unixToDate(Math.floor(Date.now() / 1000)),
        read: false,
        visible: false
      })
    } else if (typeof msgObj === 'string') {
      this.data.notifications.unshift({
        type: "info",
        title: langControl.currentLangKey['titleInfoNotification'],
        message: msgObj,
        time: iStoreUtils.unixToDate(Math.floor(Date.now() / 1000)),
        read: false,
        visible: false
      })
    }
  },
  markAsRead(notification) {
    notification.read = true
  }
}

export default notificationService
